import React from 'react';
import {
  BottomWrapper,
  ToolbarDivider,
  ToolbarIconsWrapper as TopWrapper,
  ToolbarWrapper,
} from './styles';
import { connect } from 'react-redux';
import { SIDEBAR_TYPE, ToolbarItem } from '@amzn/aac-chrome-internal-api';
import {
  selectActiveCategory,
  selectBottomToolbarItems,
  selectTopToolbarItems,
  ToolbarItemProps,
} from '../../store/slice';
import { RootState } from 'src/app/store';
import RegularIcon from './RegularIcon';
import { useSidenavBundle } from 'src/providers/PantherLocalizationProvider';

interface ToolbarProps {
  topToolbarItems: Array<ToolbarItem>;
  bottomToolbarItems: Array<ToolbarItem>;
  activeCategory: string;
}

export const Toolbar: React.VFC<ToolbarProps> = ({
  topToolbarItems,
  bottomToolbarItems,
  activeCategory,
}) => {
  const bundle = useSidenavBundle();

  const constructIcon = (item: ToolbarItem) =>
    item.sidebarType === SIDEBAR_TYPE.DIVIDER ? (
      <ToolbarDivider />
    ) : (
      <>
        {item.sidebarType === SIDEBAR_TYPE.TOOL && <ToolbarDivider />}
        <RegularIcon
          {...(item as ToolbarItemProps)}
          toolTip={
            item.sidebarType === SIDEBAR_TYPE.TOOL
              ? bundle.getMessage('sidenav-tools-and-resources-category-label')
              : item.toolTip
          }
          activeCategory={activeCategory}
        />
      </>
    );

  const topToolbarContainer = topToolbarItems.map((item, index) => (
    <div key={item.id + index}>{constructIcon(item)}</div>
  ));
  const bottomToolbarContainer = bottomToolbarItems.map((item, index) => (
    <div key={item.id + index}>{constructIcon(item)}</div>
  ));

  return (
    <ToolbarWrapper
      id="AACChromeToolbar"
      role="navigation"
      aria-label={bundle.getMessage('sidenav-global-nav-label')}
    >
      <TopWrapper>{topToolbarContainer}</TopWrapper>
      <BottomWrapper>{bottomToolbarContainer}</BottomWrapper>
    </ToolbarWrapper>
  );
};

const mapStateToProps = (state: RootState) => {
  return {
    topToolbarItems: selectTopToolbarItems(state),
    bottomToolbarItems: selectBottomToolbarItems(state),
    activeCategory: selectActiveCategory(state),
  };
};

export const ConnectedToolbar = connect(mapStateToProps)(Toolbar);
